import { useDispatch, useSelector } from "react-redux";
import googleReview from "../../../../assets/svg/googlereview.svg";
import tripadvisor from "../../../../assets/svg/tripadvisor.svg";
import booking from "../../../../assets/svg/booking.png";
import expedia from "../../../../assets/svg/expedia.png";
import goibibo from "../../../../assets/svg/goibibo.jpeg";
import airbnb from "../../../../assets/images/integration/airbnb.svg";
import agoda from "../../../../assets/images/integration/agoda.svg";
import { useAlert } from "../../../../context/AlertProvider";
import {
  connectToGoogleRM,
  getPlatformConfiguration,
  removePlatformConfiguration,
} from "../../../../actionCreator/reputationManagerActionCreator";
import { useEffect } from "react";
const originURL = window.location.origin;

const platforms = [
  {
    name: "Google Business Profile",
    logo: googleReview,
    providerType: "GOOGLE",
    platformName: "Google",
  },
  { name: "Tripadvisor", logo: tripadvisor, platformName: "TripAdvisor" },
  { name: "Booking.com", logo: booking, platformName: "Booking.com" },
  { name: "Expedia", logo: expedia, platformName: "Expedia" },
  // { name: "Hotels.com", logo: "path/to/hotels-logo.png" },
  { name: "Agoda", logo: agoda, platformName: "Agoda" },
  // { name: "Priceline", logo: "path/to/priceline-logo.png" },
  // { name: "Trip.com", logo: "path/to/tripcom-logo.png" },
  // { name: "Hotwire", logo: "path/to/hotwire-logo.png" },
  // { name: "Travelocity", logo: "path/to/travelocity-logo.png" },
  // { name: "Orbitz", logo: "path/to/orbitz-logo.png" },
  // { name: "MakeMyTrip", logo: "path/to/makemytrip-logo.png" },
  { name: "Goibibo", logo: goibibo, platformName: "Goibibo" },
  // { name: "Cleartrip", logo: "path/to/cleartrip-logo.png" },
  // { name: "Airbnb", logo: airbnb },
  // { name: "Vrbo", logo: "path/to/vrbo-logo.png" },
  // { name: "FlipKey", logo: "path/to/flipkey-logo.png" },
  // { name: "Homestays Worldwide", logo: "path/to/homestays-logo.png" },
  // { name: "HolidayIQ", logo: "path/to/holidayiq-logo.png" },
];
export const useConnectPlatforms = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const platformConfiguration = useSelector(
    (state) => state.ReputationMangerReducer.platformConfiguration
  );
  const loading = useSelector((state) => state.ReputationMangerReducer.loading);
  const handleConnect = async (payload) => {
    let res;
    switch (payload?.type) {
      case "Google Business Profile":
        res = await dispatch(
          connectToGoogleRM({ origin: originURL, email: payload?.email })
        );
        break;
      default:
        return;
    }
    if (res?.status === 200) {
      window.open(res?.data?.connectUrl);
    } else {
      showAlert("error", `Something went wrong. Please try again.`);
    }
  };

  const handleDisconnect = async () => {
    const res = await dispatch(removePlatformConfiguration());
    if (res.status === 204) {
      showAlert("success", `Your Account is Disconnected!`);
      dispatch(getPlatformConfiguration());
    } else {
      showAlert("error", `Something went wrong. Please try again.`);
    }
  };

  useEffect(() => {
    const getConfiguration = () => {
      dispatch(getPlatformConfiguration());
    };
    getConfiguration();
  }, [dispatch]);

  return {
    handleConnect,
    platforms,
    platformConfiguration,
    handleDisconnect,
  };
};
